import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=c5fa39b0&"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts&"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports